import { PROMO_SELECTED_CARD_TYPE } from 'types'

// Converts a full membership name (e.g. "Gold Card") to the short card name
// the promo endpoint expects (e.g. "Gold"), or null for cards it can't check.
const getPromoSelectedCardType = (membershipType) =>
  PROMO_SELECTED_CARD_TYPE[membershipType] ?? null

export default getPromoSelectedCardType
